const getDomain = () => {
  switch (window.env) {
    case 'prod':
    case 'prod-beta':
      return 'blockchain.com'
    case 'staging':
    case 'staging-beta':
      return 'staging.blockchain.info'
    case 'dev':
      return 'dev.blockchain.info'
    default:
      return 'blockchain.com'
  }
}

export const getMercuryGatewayWsUrl = () => `wss://ws.${getDomain()}/mercury-gateway/v1/ws`
export const getMarkeyDataWsUrl = () => {
  switch (window.env) {
    case 'prod':
    case 'prod-beta':
      return 'wss://ws.blockchain.com/mercury-market-data-lp/v2'
    case 'staging':
    case 'staging-beta':
      return 'wss://ws.staging.blockchain.info/mercury-market-data-lp/v2'
    case 'dev':
      return 'wss://ws.dev.blockchain.info/mercury-market-data-lp/v2'
    default:
      return 'wss://ws.blockchain.com/mercury-market-data-lp/v2'
  }
}
//export const getMarkeyDataWsUrl = () => `wss://ws.${getDomain()}/mercury-market-data/v2`


// TODO: service/api/* import urlbulder from src/services/api/urlBuilder.ts
// that is a pointless wrapper. We should use this function instead.
export const getApiUrl = (endpoint: string) => `https://api.${getDomain()}/${endpoint}`
